import { useNavigate } from 'react-router-dom';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import { SellApartmentFlowPaths } from 'routes';
import styles from './styles.module.scss';
import lightning from '../../assets/images/lightning.png';
import background from '../../assets/images/background.png';
import clsx from 'clsx';
import { createCallRequest } from '../../api';
import { useState } from 'react';
import useBoundStore from '../../store';

const SellReitInformation: React.FC = () => {
  const navigate = useNavigate();
  const showToast = useBoundStore((s) => s.showToast);
  const [isCallButtonLoading, setIsCallButtonIsLoading] = useState(false);
  const [isCallButtonDisabled, setIsCallButtonDisabled] = useState(false);

  const handleCreateCall = async () => {
    setIsCallButtonIsLoading(true);

    const { result } = await createCallRequest();

    if (result) {
      setIsCallButtonDisabled(true);
      showToast({ message: 'Свяжемся в течение 15 минут' });
    }

    setIsCallButtonIsLoading(false);
  };

  const buttons: ButtonProps[] = [
    {
      label: 'Запросить звонок',
      variant: 'gray',
      disabled: isCallButtonDisabled,
      loading: isCallButtonLoading,
      onClick: handleCreateCall,
    },
  ];

  return (
    <BaseScreen
      padContent
      title='Продать c Рейт'
      buttons={buttons}
      onBackButtonClick={() => navigate(-1)}
    >
      <h2 className={styles.title}>Мы поможем продать вашу квартиру c Рейт.</h2>
      <p className={styles.title}>Воспользуйтесь нашими услугами</p>

      <div className={clsx(styles.labelFileUpload)}>
        <div className={styles.uploadContent}>
          <div>
            <img src={lightning} />
          </div>
        </div>
      </div>
    </BaseScreen>
  );
};

export default SellReitInformation;
